import gql from 'graphql-tag';

import {RECURRING_TIP_FRAGMENT} from './recurringDonationQuery';

export const SUBSCRIPTIONS_PAGE = gql`
  query SubscriptionsPage {
    tipJarSubscriptions {
      ...RecurringTipFragment
    }
    tipJarTipEvents {
      id
      occurredAt
      amount
      currency
      podcast {
        slug
        name
      }
    }
  }
  ${RECURRING_TIP_FRAGMENT}
`;
